// 首页CID
export const HomePageCid = '';
//
export const ProductCardMv = 'b_waimai_c_overseas_vb9w5duu_mv';
export const ProductCardGroupInfoMv = 'b_sailor_c_adwj0jjj_mv';

//
export const ProductCardMc = 'b_waimai_c_overseas_vb9w5duu_mc';
export const ProductCardGroupInfoMC = 'b_sailor_c_adwj0jjj_mc';

export const BigPicCardTempID = 'mach_pro_sailor_c_feed_common_big_pic_golden_card';
